const types = {
	//Get Template name
	GET_ACCOMMODATION_START: "GET_ACCOMMODATION_START",
	GET_ACCOMMODATION_SUCCESS: "GET_ACCOMMODATION_SUCCESS",
	GET_ACCOMMODATION_ERROR: "GET_ACCOMMODATION_ERROR",
	GET_ACCOMMODATION_RESET: "GET_ACCOMMODATION_RESET",

	//Create Template name
	CREATE_ACCOMMODATION_START: "CREATE_ACCOMMODATION_START",
	CREATE_ACCOMMODATION_SUCCESS: "CREATE_ACCOMMODATION_SUCCESS",
	CREATE_ACCOMMODATION_ERROR: "CREATE_ACCOMMODATION_ERROR",
	CREATE_ACCOMMODATION_RESET: "CREATE_ACCOMMODATION_RESET",

	//delete Template name
	DELETE_ACCOMMODATION_START: "DELETE_ACCOMMODATION_START",
	DELETE_ACCOMMODATION_SUCCESS: "DELETE_ACCOMMODATION_SUCCESS",
	DELETE_ACCOMMODATION_ERROR: "DELETE_ACCOMMODATION_ERROR",
	DELETE_ACCOMMODATION_RESET: "DELETE_ACCOMMODATION_RESET",

	//update Template name
	UPDATE_ACCOMMODATION_START: "UPDATE_ACCOMMODATION_START",
	UPDATE_ACCOMMODATION_SUCCESS: "UPDATE_ACCOMMODATION_SUCCESS",
	UPDATE_ACCOMMODATION_ERROR: "UPDATE_ACCOMMODATION_ERROR",
	UPDATE_ACCOMMODATION_RESET: "UPDATE_ACCOMMODATION_RESET",

	//single item  name
	SINGLE_ACCOMMODATION_START: "SINGLE_ACCOMMODATION_START",
	SINGLE_ACCOMMODATION_SUCCESS: "SINGLE_ACCOMMODATION_SUCCESS",
	SINGLE_ACCOMMODATION_ERROR: "SINGLE_ACCOMMODATION_ERROR",
	SINGLE_ACCOMMODATION_RESET: "SINGLE_ACCOMMODATION_RESET",
};

export default types;
